import React, { useContext, useState } from "react";
import Chip from "../../common/Chip";

import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowRightDisabledSvg } from "../../../assets/icons/arrow-right-disabled.svg";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/icons/arrow-left.svg";
import OnboardContext from "../context";
import { Form, Formik } from "formik";
import Button from "../../common/Button";
import { langComponent } from "../../../constants";
import AppContext from "../../../AppContext";

const Works = () => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.onboard);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationWorkType = getLang(langComponent.workType);
  const { designWorks, goBack, goForward, information, addInformation } =
    useContext(OnboardContext);
  const [selected, setSelected] = useState(information.interestWork || []);

  const handleOptionClick = (id, selection) => {
    // * Add to list
    if (selection) {
      const _works = selected.concat([id]);
      setSelected(_works);
      return;
    }

    // * Remove from selection
    if (!selection) {
      const _works = selection.filter((w) => w !== id);
      setSelected(_works);
    }
  };

  const handleSkip = () => {
    addInformation({ interestWork: undefined });
    goForward();
  };

  const handleSubmit = () => {
    if (!selected || selected.length === 0) return;
    addInformation({ interestWork: selected });
    goForward();
  };

  return (
    <div className="onboard-interests">
      <h1 className="onboard__header">
        {Translation("What type of works are you interested in?")}
      </h1>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        <Form className="onboard__form onboard__form-interests">
          <div className="onboard-interests__options">
            {designWorks.map(({ _id, name }, index) => {
              return (
                <Chip
                  id={_id}
                  label={TranslationWorkType(name)}
                  onClick={handleOptionClick}
                  key={`interest-key-${_id}`}
                  selected={selected.find((f) => f === _id) !== undefined}
                />
              );
            })}
          </div>
          <div className="onboard__form-cta">
            <Button
              label={TranslationCommon("Return")}
              leadingIcon={<ArrowLeftSvg />}
              onClick={goBack}
              variant="secondary"
            />
            <div className="onboard__form-cta__divider" />
            <Button
              label={TranslationCommon("Skip")}
              variant="tertiary"
              onClick={handleSkip}
            />
            <Button
              type="submit"
              label={TranslationCommon("Continue")}
              trailingIcon={
                selected.length > 0 ? (
                  <ArrowRightSvg />
                ) : (
                  <ArrowRightDisabledSvg />
                )
              }
              disabled={selected.length === 0}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

Works.propTypes = {};

export default Works;
